module.exports = __webpack_public_path__ + "static/img/step1.d303cfc6.png";